import {
    NEWFCM,SHOW_LOADING,UPDATEFCM,SENDFCM
} from "../constants/FCMCredentials";
import {
    AUTH_TOKEN, HIDE_AUTH_MESSAGE, SHOW_AUTH_MESSAGE
} from "../constants/Auth";

const initState = {
    loading: false,
    message: '',
    showMessage: false,
    redirect: '',
    token: localStorage.getItem(AUTH_TOKEN),
}

const FCM = (state = initState, action) => {
    switch (action.type) {
        case NEWFCM:
            return {
                ...state,
                loading: false,
                message: action.message,
                showMessage: true,
            }
        case SHOW_AUTH_MESSAGE:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false
            }
        case UPDATEFCM:
            return {
                ...state,
                message: action.message,
                showMessage: true,
                loading: false,
            }
        case HIDE_AUTH_MESSAGE:
            return {
                ...state,
                message: '',
                showMessage: false,
            }
        case SHOW_LOADING: {
            return {
                ...state,
                loading: true
            }
        }
        case SENDFCM: {
            return {
                ...state,
                loading: true
            }
        }
        default:
            return state;
    }
}

export default FCM